export default __webpack_public_path__ + "static/media/infectology.f77830ff.jpg";